import { SVGProps, Ref, forwardRef } from 'react'
const SvgPhone = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.086 7.402a2.315 2.315 0 0 0 0-3.27L6.632 1.676a2.315 2.315 0 0 0-3.272 0L2.016 3.023a3.463 3.463 0 0 0-.439 4.365 53.794 53.794 0 0 0 15.034 15.035 3.47 3.47 0 0 0 4.366-.438l1.345-1.346a2.31 2.31 0 0 0 0-3.27l-2.453-2.453a2.31 2.31 0 0 0-3.271 0l-.818.817A54.823 54.823 0 0 1 8.268 8.22l.818-.817Z"
      clipRule="evenodd"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPhone)
export default ForwardRef
